import { adminColors } from '../../../styles/adminDesignTokens';

export const FEATURE_FLAG_SELECTOR_LIST_SX = {
  border: `1px solid ${adminColors.border}`,
  borderRadius: '8px',
  maxHeight: 'clamp(300px, 42vh, 420px)',
  overflowY: 'auto',
};

export const FEATURE_FLAG_SELECTOR_STATE_SX = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  minHeight: 120,
  p: 1.5,
  textAlign: 'center',
};
